import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { routeTypes, routeActions } = createActionsStructure('route', [
  { name: 'GET_ROUTES', async: true },
  { name: 'ADD_WAITING_PASSENGER_TO_SHEET', async: true },
  { name: 'DELETE_WAITING_PASSENGER', async: true },
  { name: 'SET_WAITING_PASSENGER', async: true },
  { name: 'SUBSCRIBE_WAITING_PASSENGERS', async: true },
  { name: 'UNSUBSCRIBE_WAITING_PASSENGERS', async: false },
  { name: 'CHANGE_ROUTE_LIMIT', async: true },
  { name: 'SELECT_ROUTE', async: false },
  { name: 'CHANGE_ROUTE_INFO', async: false },
  { name: 'SUBSCRIBE_INFO', async: true },
  { name: 'UNSUBSCRIBE_INFO', async: false },
  { name: 'SET_ROUTE_INFO', async: true },
  { name: 'CHANGE_SOURCE_DATA', async: false },
  { name: 'SET_SOURCE_DATA', async: true },
  { name: 'DISABLE_ROUTE', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/RouteActions.js